export default "/images/vendor/flag-icon-css/flags/1x1/th.svg?2ca3db46e2b26412705d4c1c0b6ced04";